<div class="logo-container">
    <img src="assets/img/logo_small.png" alt="logo" />
</div>
<router-outlet></router-outlet>
<footer class="py-4">
    <div class="container">
        <div class="row align-items-center">
            <div class="col">
                <div class="copyright text-center">
                    &copy; {{ test | date: "yyyy" }}
                    Stratipath
                </div>
            </div>
        </div>
    </div>
</footer>